import { ShieldAlert } from 'lucide-react'

import type { PermissionCode } from '@/lib/permissions'

/** The same shape every ledger screen uses for "you may not read this" — see `ledger/permissions.ts`. */
export function RestrictedPanel({ what, permission }: { what: string; permission: PermissionCode }) {
  return (
    <div className="flex flex-col items-center gap-2 rounded-card border border-border-subtle bg-surface px-4 py-12 text-center">
      <ShieldAlert className="size-6 text-warning-text" aria-hidden />
      <p className="text-sm font-medium text-heading">{what} is restricted</p>
      <p className="max-w-lg text-xs text-muted">
        Reading it needs <span className="font-mono">{permission}</span>, which your role does not
        hold.
      </p>
    </div>
  )
}
